import {
  Box,
  SimpleGrid,
  Text,
  VStack,
  useColorModeValue,
} from '@chakra-ui/react';

import { formatDate } from '../../constants';
import type { QuoteSummaryRiskInfo } from 'api/quote-marketplace';

interface RatesSectionProps {
  effectiveDate: string;
  validUntilDate: string | null;
  riskInfo: QuoteSummaryRiskInfo | null;
}

const RatesSection = ({
  effectiveDate,
  validUntilDate,
  riskInfo,
}: RatesSectionProps) => {
  const labelColor = useColorModeValue('gray.500', 'gray.400');

  return (
    <Box mb={6}>
      <Text fontWeight="600" fontSize="sm" mb={3}>
        Rates
      </Text>
      <SimpleGrid columns={{ base: 2, md: 3 }} spacing={4}>
        <VStack align="flex-start" spacing={0}>
          <Text fontSize="xs" color={labelColor}>
            Effective Date
          </Text>
          <Text fontSize="sm">{formatDate(effectiveDate)}</Text>
        </VStack>
        <VStack align="flex-start" spacing={0}>
          <Text fontSize="xs" color={labelColor}>
            VRG Effective Date
          </Text>
          <Text fontSize="sm">{formatDate(riskInfo?.vrg_effective_date)}</Text>
        </VStack>
        <VStack align="flex-start" spacing={0}>
          <Text fontSize="xs" color={labelColor}>
            Quote Valid Until
          </Text>
          <Text fontSize="sm">{formatDate(validUntilDate)}</Text>
        </VStack>
      </SimpleGrid>
    </Box>
  );
};

export default RatesSection;
